import React from 'react';
import { Modal, Form, InputNumber } from 'antd';
import type { ShippingRateTier } from '../../../../types/shipping-types';

interface RateTierModalProps {
    visible: boolean;
    editingTier: Partial<ShippingRateTier> | null;
    form: any;
    onOk: () => void;
    onCancel: () => void;
}

export const RateTierModal: React.FC<RateTierModalProps> = ({
    visible,
    editingTier,
    form,
    onOk,
    onCancel,
}) => {
    return (
        <Modal
            title={editingTier ? '编辑运费阶梯' : '添加运费阶梯'}
            open={visible}
            onOk={onOk}
            onCancel={onCancel}
        >
            <Form form={form} layout="vertical">
                <Form.Item name="min_weight" label="最小重量(kg)" rules={[{ required: true }]}>
                    <InputNumber style={{ width: '100%' }} min={0} step={0.01} />
                </Form.Item>

                <Form.Item name="max_weight" label="最大重量(kg)" tooltip="留空表示无上限">
                    <InputNumber style={{ width: '100%' }} min={0} step={0.01} />
                </Form.Item>

                <Form.Item name="price_per_kg" label="单价(¥/kg)" rules={[{ required: true }]}>
                    <InputNumber style={{ width: '100%' }} min={0} step={0.01} prefix="¥" />
                </Form.Item>

                <Form.Item name="base_fee" label="起步价(¥)" initialValue={0}>
                    <InputNumber style={{ width: '100%' }} min={0} step={0.01} prefix="¥" />
                </Form.Item>
            </Form>
        </Modal>
    );
};
